import React from 'react'
import { MeasureTypeRadioButtons } from './MeasureTypeRadioButtons'
import { useSizeFilter } from './useSizeFilter'
import { FilterGroup } from './FilterGroup'
import { Stack } from 'react-bootstrap'
import { SizeNumberInput } from './SizeNumberInput'

export const HorizontalSize = () => {
  const { value, measureType, maximumValue, onChange, onChangeMeasureType, step } = useSizeFilter({
    type: 'horizontal',
  })

  return (
    <FilterGroup filterName="horizontalSize" title="(Size) Horizontal/Over Flat">
      <Stack gap={2}>
        <SizeNumberInput value={value} onChange={onChange} maximumValue={maximumValue} step={step} />

        <MeasureTypeRadioButtons name="horizontalMeasureTye" onChange={onChangeMeasureType} measureType={measureType} />
      </Stack>
    </FilterGroup>
  )
}
